/* FIXME: use redux-toolkit and avoid a lot of the boiler-plate in reducers */
import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import caseApp from './cases/reducer';

const reducers = combineReducers({
  menu,
  settings,
  authUser,
  caseApp,
});

export default reducers;
